export default __webpack_public_path__ + "static/media/phoneInput.cc5f9dfe.svg";